import React, { useState } from "react";
import Chat from "../Chat/Chat";
import "./Content.css";

const options = [
  { value: 'en', label: "English" },
  { value: 'es', label: "Spanish" },
  { value: 'fr', label: "French" },
  { value: 'de', label: "German" },
  { value: 'it', label: "Italian" },
  { value: 'pl', label: "Polish" },
  { value: 'uk', label: "Ukrainian" },
  { value: 'tr', label: "Turkish" },
  { value: 'ru', label: "Russian" }
];

const Content = ({ switcher }) => {
  // State for speaker language
  const [speakerLanguage, setSpeakerLanguage] = useState("");

  // State for subtitles language
  const [subtitlesLanguage, setSubtitlesLanguage] = useState("");

  // Handler for speaker language change
  const handleSpeakerLanguageChange = (e) => {
    setSpeakerLanguage(e.target.value);
  };

  // Handler for subtitles language change
  const handleSubtitlesLanguageChange = (e) => {
    setSubtitlesLanguage(e.target.value);
  };

  return (
    <div className="content">
      <div>
        <Chat switcher={switcher} inputLanguage={speakerLanguage} outputLanguage={subtitlesLanguage} />
      </div>
      <div className="content__settings">
        <h3>Speaker language</h3>
        <div className="selectdiv">
          <select
            className="input__select"
            value={speakerLanguage}
            onChange={handleSpeakerLanguageChange}
          >
            <option value="" disabled>
              Select an option
            </option>
            {options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <h3>Subtitles language</h3>
        <div className="selectdiv">
          <select
            className="input__select"
            value={subtitlesLanguage}
            onChange={handleSubtitlesLanguageChange}
          >
            <option value="" disabled>
              Select an option
            </option>
            {options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default Content;
